





























































































































import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { Component, Vue } from "vue-property-decorator";
import { getOperationLogApi, getOperationCodeApi } from "@/api/store";
import { dateFormat } from "@/utils/timeFormat";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    CommonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo = {
    create_time: "",
    detail: "",
    code: [],
    staff_id: "",
    sort_type: "desc",
    sort_field: "create_time",
  };
  tableData = [];
  total = 0;
  page = 1;
  searchCodeList: { key: number; value: string }[] = [];
  searchCodeObject: any = {};
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  created() {
    this.getList({
      page: 1,
      page_size: 10,
    });
    getOperationCodeApi().then((res: any) => {
      const resList = res.data.list || [];
      this.searchCodeList = resList;
      resList.map((item: any) => {
        this.searchCodeObject[item.key] = item.value;
      });
    });
  }
  getList(data: { page: number; page_size: number }) {
    const option: any = {
      page: data.page,
      page_size: data.page_size,
      sort_field: this.searchInfo.sort_field,
      sort_type: this.searchInfo.sort_type,
    };
    if (this.searchInfo.detail) {
      option.detail = this.searchInfo.detail;
    }
    if (this.searchInfo.code && this.searchInfo.code.length > 0) {
      option.code = this.searchInfo.code;
    }
    if (this.searchInfo.staff_id) {
      option.staff_id = this.searchInfo.staff_id;
    }
    if (
      this.searchInfo.create_time &&
      this.searchInfo.create_time.length === 2
    ) {
      option.create_time_start = this.searchInfo.create_time[0];
      option.create_time_end = this.searchInfo.create_time[1];
    }
    getOperationLogApi(option).then((res: any) => {
      const resList = res.data.list || [];
      resList.map((item: any) => {
        item.create_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          item.create_time * 1000
        );
      });
      this.tableData = resList;
      this.total = res.data.total;
      this.page = data.page;
    });
  }
  clickSort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  handleSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleCurrentChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handleSearchReset() {
    this.searchInfo = {
      create_time: "",
      detail: "",
      code: [],
      staff_id: "",
      sort_type: "desc",
      sort_field: "create_time",
    };
    this.handleSearch();
  }
}
